var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"space-y-4"},[_c('FormHeader',{attrs:{"title":_vm.$t('gamerInfoStep.title')}}),_c('div',{staticClass:"space-y-4"},[_c('VideoGameSelection'),_c('ConsoleSelection')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }